import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import "./StudentDetail.css";
import axios from "axios";
import img from "../../image.png"
import { useMutation } from 'react-query';
import {url} from '../../BaseUrl'
function StudentDetail() {
  const { id } = useParams();
  const location = useLocation();
  const { students } = location.state || {};

  const student = [students].find((student) => student._id === id);
  const [feeStatus, setFeeStatus] = useState(student.fees);
  const [loadingMonth, setLoadingMonth] = useState(null); // Track loading for specific month
  const payFeesMutation = useMutation({
    mutationFn: async ({ month, email, phone }) => {
      const token = sessionStorage.getItem("token");
      const response = await axios.post(
        `${url}/api/auth/payfees`,
        { month, email, phone },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    },
    onSuccess: (data, variables) => {
      setFeeStatus((prevStatus) => ({
        ...prevStatus,
        [variables.month]: true,
      }));
      alert(`Your payment for ${variables.month} will be updated soon.`);
    },
    onError: () => {
      alert("Failed to process payment. Please try again.");
    },
  });

  
  const handleFeeSubmission = async (month,email,phone) => {
//     const token = sessionStorage.getItem("token");
//     // setFeeStatus((prevState) => ({
//     //   ...prevState,
//     //   [month]: "true",
//     // }));
//    const response = await axios.post('http://localhost:8000/api/auth/payfees',{month,email,phone},{
//     headers: {
//       Authorization: `Bearer ${token}`,
//       "Content-Type": "application/json",
//     },


//   })
//   if (response.status == 200) {
//     alert(`Your payment for ${month} will be updated soon.`);
// }
//   console.log("payfees",response,response.status)
//   return response.data;
payFeesMutation.mutate({ month, email, phone });
  };


  const mutation = useMutation({
    mutationFn: async (emailData) => {
      const token = sessionStorage.getItem("token");
      const response = await axios.post(
        `${url}/api/auth/feeReminder`,
        emailData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    },
    onSuccess: (data) => {
      alert("Email sent successfully!");
      setLoadingMonth(null); // Reset loading state
    },
    onError: (error) => {
      alert("Failed to send email. Please try again.");
      setLoadingMonth(null); // Reset loading state
    },
  });

  const handleEmailReminder = (email, studentName, month) => {
    setLoadingMonth(month); // Set loading for this specific month
    const emailData = {
      email,
      studentName,
      month,
    };
    mutation.mutate(emailData);
  };

  if (!student)
    return <div className="student-not-found">Student not found</div>;

  return (
    <div className="student-detail">
      <div className="card student-info-card">
        <img
          src={img}
          alt="Student Photo"
          className="student-photo"
        />
        <div className="student-info">
          <h2>
            {students.firstName} {students.lastName}
          </h2>
          <p><strong>Email:</strong> {students.email}</p>
          <p><strong>Phone Number:</strong> {students.phone}</p>
          <p><strong>Monthly Fees:</strong>₹{students.totalFees}</p>
        </div>
      </div>

      <div className="card fee-status-card">
        <h3>Fee Payment Status</h3>
        <div className="fee-list">
          {[
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ].map((month, index) => (
            <div key={index} className="fee-item">
              <div className="fee-month">{month}</div>
              <div
                className={`fee-status ${feeStatus[month] === true ? "paid" : "unpaid"}`}
              >
                {feeStatus[month] === true ? "Paid" : "Unpaid"}
              </div>
              {feeStatus[month] === false && (
                <div className="fee-actions">
                  <button
                    onClick={() => handleFeeSubmission(month,students.email,students.phone)}
                    className="submit-btn"
                    disabled={payFeesMutation.isLoading}
                  >
                      Mark as Paid
                  </button>
                  <button
                    onClick={() =>
                      handleEmailReminder(
                        students.email,
                        `${students.firstName} ${students.lastName}`,
                        month
                      )
                    }
                    className="reminder-btn"
                    disabled={loadingMonth === month} // Disable only the clicked button
                  >
                    {loadingMonth === month ? "Sending..." : "Send Reminder"}
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default StudentDetail;
